// extracted by mini-css-extract-plugin
module.exports = {"appError":"styles_appError__3anTi","errorImageWrapper":"styles_errorImageWrapper__plhAR","errorLabel":"styles_errorLabel__2SmQW"};